module.exports = __webpack_public_path__ + "static/media/right_arrow_enable.73e5608b.svg";